export enum OTP_FOR {
  REGISTER = 1,
  LOGIN = 2,
  FORGOT_PASSWORD = 3,
  VERIFICATION = 4,
}

export const PRODUCT_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export enum COLORS {
  RED = "Red",
  GREEN = "Green",
  BLUE = "Blue",
  YELLOW = "Yellow",
  CYAN = "Cyan",
  MAGENTA = "Magenta",
  ORANGE = "Orange",
  PURPLE = "Purple",
  PINK = "Pink",
  BROWN = "Brown",
  GRAY = "Gray",
  BLACK = "Black",
  WHITE = "White",
  LIGHTGRAY = "LightGray",
  DARKGRAY = "DarkGray",
  LIME = "Lime",
  OLIVE = "Olive",
  NAVY = "Navy",
  TEAL = "Teal",
  MAROON = "Maroon",
  CORAL = "Coral",
  SALMON = "Salmon",
  KHAKI = "Khaki",
  BEIGE = "Beige",
  IVORY = "Ivory",
  TURQUOISE = "Turquoise",
  AQUA = "Aqua",
  SKYBLUE = "SkyBlue",
  ROYALBLUE = "RoyalBlue",
  INDIGO = "Indigo",
  VIOLET = "Violet",
  PLUM = "Plum",
  LAVENDER = "Lavender",
  ORCHID = "Orchid",
  GOLD = "Gold",
  SILVER = "Silver",
  CRIMSON = "Crimson",
  FIREBRICK = "FireBrick",
  TOMATO = "Tomato",
  PEACHPUFF = "PeachPuff",
  MOCCASIN = "Moccasin",
  WHEAT = "Wheat",
  SANDYBROWN = "SandyBrown",
  TAN = "Tan",
  CHOCOLATE = "Chocolate",
  PERU = "Peru",
  SLATEBLUE = "SlateBlue",
  SLATEGRAY = "SlateGray",
  SEAGREEN = "SeaGreen",
  FORESTGREEN = "ForestGreen",
  DARKCYAN = "DarkCyan",
}

export enum NOTIFICATION_TYPE {
  PUSH = "BROADCAST",
  EMAIL = "EMAIL",
}
